<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <sui-grid
        ref="gridScrap"
        :columns="columnScrap"
        :dataset="'dsScrap'"
        :showDisplayCountControl="true"
        :multiselect="false"
        :showCountControl="true"
        :initialPagesize="10"
      />
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:delete="contextPageId"
          type="button"
          class="comm_btn_border"
          @click="onDeleteClick"
        >
          {{ $t('MSG_BTN_DEL') }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';

const dateTypeFields = ['firstRegistrationDTM', 'finalModificationDTM'];
/* eslint max-len: ["error", { "code" : 500 }] */
export default {
  name: 'PGE_CLB_00032', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsScrap',
    type: 'local',
    datafields: [
      {
        name: 'dataset-row-id',
        type: 'string',
        map: 'dataset-row-id',
      },
      {
        name: 'bbsName',
        type: 'string',
        map: 'bbsName',
      },
      {
        name: 'bbsCategoryItemNm',
        type: 'string',
        map: 'bbsCategoryItemNm',
      },
      {
        name: 'noticoobjTitle',
        type: 'string',
        map: 'noticoobjTitle',
      },
      {
        name: 'registrantName',
        type: 'string',
        map: 'registrantName',
      },
      {
        name: 'firstRegistrationDTM',
        type: 'string',
        map: 'firstRegistrationDTM',
      },
      {
        name: 'postUID',
        type: 'string',
        map: 'postUID',
      },
      {
        name: 'bbsTypeCode',
        type: 'string',
        map: 'bbsTypeCode',
      },
    ],
  }],
  created() {
    this.columnScrap = [
      {
        text: this.$t('MSG_TXT_SN'),
        datafield: 'dataset-row-id',
        width: '50px',
      },
      {
        text: this.$t('MSG_TXT_BBS_NM'),
        datafield: 'bbsName',
        width: '200px',
      },
      {
        text: this.$t('MSG_TXT_CATG'),
        datafield: 'bbsCategoryItemNm',
        width: '100px',
      },
      {
        text: this.$t('MSG_TXT_TITLE'),
        datafield: 'noticoobjTitle',
        // createwidget: (row, column, value, htmlElement) => {
        //   utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
        //     handler: this.onDetailClick,
        //     type: 'sublink',
        //   }, this.dsScrap, this.$refs.gridScrap);
        // },
        // initwidget(row, column, value, htmlElement) {
        //   utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        // },
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
            handler: this.onDetailClick,
          }, this.dsScrap, this.$refs.gridScrap);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_FST_RGST_USR'),
        datafield: 'registrantName',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
            datafieldMap: {
              displayLanguageId: 'displayLanguageId',
              knoxId: 'knoxId',
              userName: 'userName',
              userGlobalName: 'userGlobalName',
              loginId: 'loginId',
            },
          }, this.dsScrap, this.$refs.gridScrap);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_RGST_DTM'),
        datafield: 'firstRegistrationDTM',
        width: '200px',
      },
    ];
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      this.onSearchClick();
    },
    onSearchClick() {
      this.dsScrap.setRawData([]);

      this.searchScrap();
    },
    searchScrap() {
      http.request(this.contextPageId, 'DTS_CLB_00066', {
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateTypeFields);

        // CellButtonList 사용할 경우
        utils.forEach(res.data, item => {
          utils.forEach(item, (values, key) => {
            if (key === 'noticoobjTitle') {
              // eslint-disable-next-line no-param-reassign
              item[key] = [{ key: values, label: values, type: 'sublink' }];
            }
          });
        });

        this.dsScrap.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    onClosePagePopup() {
      this.onSearchClick();
    },
    onDetailClick(btn, selectedRow) {
      if (selectedRow) {
        utils.openLayerPopup('PGE_CLB_00033', this.onRequestInfoCallback, {
          size: 'xlg',
          pageInitialData: {
            postIdParam: selectedRow.noticoobjUid,
            bbsName: selectedRow.bbsName,
            bbsId: selectedRow.bbsId,
            pageId: this.contextPageId,
            bbsTypeCode: selectedRow.bbsTypeCode,
          },
        });
      }
    },
    onRequestInfoCallback(value) {
      if (value) {
        this.onSearchClick();
      }
    },
    onDeleteClick() {
      const selectedIndexes = this.dsScrap.getSelectedIndexes();
      const noticoobjUid = [];
      if (selectedIndexes.length < 1) {
        utils.messageBox('warning', this.$t('MSG_ALT_DEL_DATA_SELT'));
        return false;
      }
      utils.forEach(selectedIndexes, index => {
        noticoobjUid.push({
          noticoobjUid: this.dsScrap.data[index].noticoobjUid,
          bbsId: this.dsScrap.data[index].bbsId,
        });
      });
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_DEL'), null, () => {
        // http.requestTest('delete', `/api/v1/common/email/${emailUid}`, {
        http.request(this.contextPageId, 'DTS_CLB_00068', {
          data: noticoobjUid,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DELETED'));
          this.onSearchClick();
        });
      });
      return true;
    },
  },
};
</script>

<style scoped>
</style>
